import _ from 'lodash';

import { APIClient } from './APIClient';
import UserStore from '../stores/UserStore';
import TokenStore from "../stores/TokenStore";

//Re-export the errors to make it easy to import
export { RequestError, ServerError, BadRequestError, UnauthorisedError, NotFoundError } from '../errors/API';

class IblocksAPIClient extends APIClient {

    getHeaders () {
        return Object.assign({}, super.getHeaders(), _.pickBy({
            'x-customer-token': TokenStore.getCustomer(),
            'x-customer-device': TokenStore.getDevice(),
            'user-id': `${UserStore.getCurrent().id}`,
            'user-role': 'CUSTOMER'
        }, _.isString));
    }

}


export default new IblocksAPIClient();
